import PropTypes from 'prop-types';
import { StyledBundleGroup } from "./primitives";
var BundleGroup = StyledBundleGroup;
BundleGroup.propTypes = {
  children: PropTypes.node.isRequired,
  alignBodyContent: PropTypes.bool
};
export default BundleGroup;